module.exports = __webpack_public_path__ + "static/media/color2.dd1943f8.PNG";